<h3-annotation-list-section-header
  *ngIf="sectionNameLabel"
  [label]="sectionNameLabel"
></h3-annotation-list-section-header>
<ng-content select="h3-annotation-list-section-header"></ng-content>
<ng-content select=":not(h3-annotation-list-section-header)"></ng-content>
